import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-location-result.css.lit';
import { ResizeController } from '../../controllers/resize-controller';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';

/**
 * The Tufts Location Search Results component
 * @element tufts-location-result
 *
 * @slot - tag
 * @slot - image
 * @slot - title
 * @slot - distance-hours
 * @slot - info-phone
 * @slot - info-address
 * @slot - cta
 *
 */

@customElement('tufts-location-result')
export class tuftsSearchLocationResult extends OutlineElement {
  ngSlot = new SlotNGController(this);
  resizeController: ResizeController = new ResizeController(this, {
    breakpoints: [500],
  });
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];
  render(): TemplateResult {
    const classes = {
      'card-wrapper': true,
      'mobile': this.resizeController.currentBreakpointRange === 0,
    };
    return html`
      <section class="${classMap(classes)}">
        <div class="image-column">
          <div
            class="image-wrapper ${!this.ngSlot.exist('location-image')
              ? 'placeholder-image'
              : ''}"
          >
            ${this.ngSlot.conditionalNGSlot('location-tag')}
            ${this.ngSlot.conditionalNGSlot('location-image')}
          </div>
        </div>
        <div class="content-column">
          ${this.ngSlot.conditionalNGSlot('title', true, 'lg')}
          ${this.ngSlot.conditionalNGSlot('distance-hours')}
          <div class="info-column">
            ${this.ngSlot.conditionalNGSlot('info-phone')}
            ${this.ngSlot.conditionalNGSlot('info-address')}
          </div>
          ${this.ngSlot.conditionalNGSlot('cta')}
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-location-result': tuftsSearchLocationResult;
  }
}
